"use strict";
// Class definition
import Swiper from "swiper";
import {Autoplay, Grid, Navigation, Pagination, Thumbs} from "swiper/modules"
import Swal from 'sweetalert2'
import 'animate.css';
import SwiperAnimation from '@cycjimmy/swiper-animation';
import {Modal, Tab, Tooltip} from 'bootstrap';
import SVGInject from '@iconfu/svg-inject';
import Cookies from 'js-cookie'
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {isScrolledIntoView, intTelInput} from "./General";

var App = function () {
    let swiperAnimation;
    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Grid]);
        swiperAnimation = new SwiperAnimation();
    }
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined && this.length > 0;
    }

    const home = () => {
        var interleaveOffset = 0.5;

        let videos = document.querySelectorAll('.home-slider .swiper-slide video');
        videos.forEach(function ($el) {
            let ths = $el;
            let load = setInterval(function () {
                if (ths.readyState >= 1) {
                    let duration = (ths.duration * 1000) - 1000
                    if (duration > 0) {
                        ths.closest(".swiper-slide").setAttribute('data-swiper-autoplay', duration);
                    }
                    clearInterval(load);
                }
            }, 100)
        });

        let home_slider;
        home_slider = new Swiper('.home-slider', {
            loop: false,
            speed: 1000,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            on: {
                progress: function (swiper, progress) {
                    for (var i = 0; i < swiper.slides.length; i++) {
                        var slideProgress = swiper.slides[i].progress;
                        var innerOffset = swiper.width * interleaveOffset;
                        var innerTranslate = slideProgress * innerOffset;
                        swiper.slides[i].querySelector(".slide-background").style.transform =
                            "translate3d(" + innerTranslate + "px, 0, 0)";
                    }
                },
                touchStart: function () {
                    var swiper = this;
                    for (var i = 0; i < swiper.slides.length; i++) {
                        swiper.slides[i].style.transition = "";
                    }
                },
                setTransition: function (swiper, speed) {
                    for (var i = 0; i < swiper.slides.length; i++) {
                        swiper.slides[i].style.transition = speed + "ms";
                        swiper.slides[i].querySelector(".slide-background").style.transition =
                            speed + "ms";
                    }
                },
                init: function () {
                    swiperAnimation.init(this).animate();

                    var currentVideo = $("[data-swiper-slide-index=" + this.realIndex + "]").find("video");
                    currentVideo.trigger('play');

                },
                slideChange: function (swiper) {
                    swiperAnimation.init(this).animate();

                    videos.forEach(function (ths) {
                        ths.currentTime = 0;
                    });
                    var prevVideo = $("[data-swiper-slide-index=" + this.previousIndex + "]").find("video");
                    var currentVideo = $("[data-swiper-slide-index=" + this.realIndex + "]").find("video");
                    prevVideo.trigger('stop');
                    currentVideo.trigger('play');
                }
            }
        });

        /*
                $('.tab-content .background').each(function () {
                    let wrapper = $(this)
                    wrapper.find('.list li').each(function () {
                        let li = $(this);
                        let activeElem = wrapper.find('.list li.active');

                        if (li.hasClass('active'))
                            wrapper.css('background-image', 'url(' + li.attr('data-background') + ')');

                        $(li).click(function () {
                            if (wrapper.find('.temp-background').exists()) {
                                wrapper.find('.temp-background').css('background-image', 'url(' + $(this).attr('data-background') + ')');
                            } else {
                                $('<div class="temp-background"></div>').css({
                                    'background-image': activeElem.attr('data-background'),
                                    'position': 'absolute',
                                    'top': 0,
                                    'left': 0,
                                    'width': '100%',
                                    'height': '100%',
                                    'z-index': -1
                                }).appendTo(wrapper);
                            }

                            wrapper.find('.list li').removeClass('active');

                            $(this).addClass('active');
                            let newBackground = 'url(' + $(this).attr('data-background') + ')';


                            // Mevcut arka planın fade out efekti
                            wrapper.fadeOut(200, function () {
                                // Temizlik: Geçici arka plan öğesini kaldır
                                // $('.temp-background').remove();
                                // Yeni arka planı ayarla
                                wrapper.css('background-image', newBackground).fadeIn(200);
                            });
                        })
                    })
                })
        */

        new Swiper('.showcase-solutions .swiper', {
            slidesPerView: 3,
            spaceBetween: 20,
            // navigation: {
            //     prevEl: '.showcase-solutions .swiper-prev',
            //     nextEl: '.showcase-solutions .swiper-next'
            // },
            pagination: {
                el: '.showcase-solutions .slides .swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                660: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 40
                }
            }
        })

        new Swiper('.home-others .catalog .swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.home-others .catalog .swiper-pagination',
                clickable: true
            }
        })

        new Swiper('.home-others .cartels', {
            slidesPerView: 1,
            spaceBetween: 24,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                550: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 0
                }
            }
        })

        new Swiper('.home-others .references', {
            slidesPerView: 1,
            spaceBetween: 24,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                550: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 0
                }
            }
        })

        new Swiper('.home-about .images .swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        })
    }

    let pages = () => {

        new Swiper('.related-products .slides .swiper', {
            slidesPerView: 5,
            spaceBetween: 0,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false
            // },
            navigation: {
                prevEl: '.related-products .swiper-prev',
                nextEl: '.related-products .swiper-next'
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                },
                1400: {
                    slidesPerView: 5
                }
            }
        })

        new Swiper('.related-solutions .swiper', {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 34,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                992: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                1200: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            }
        })

        new Swiper('.related-blogs .swiper', {
            slidesPerView: 4,
            spaceBetween: 20,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                },
                1400: {
                    spaceBetween: 46,
                }
            }
        })

        document.querySelectorAll('.widget .is-main-category ul li ul li a').forEach((item) => {
            item.classList.add('active');
        })

        document.querySelectorAll('.widget .list ul li ul li a').forEach((item) => {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                } else {
                    item.classList.add('active');
                }

                const activeItems = document.querySelectorAll('.widget .list ul li ul li a.active');

                let activeClassNames = [];
                activeItems.forEach((activeItem) => {
                    const url = new URL(activeItem.href);
                    const pathParts = url.pathname.split('/');
                    const className = pathParts[pathParts.length - 1];
                    activeClassNames.push(className);
                });

                const productItems = document.querySelectorAll('.product-item-wrapper');

                productItems.forEach((productItem) => {
                    let hasClass = false;

                    if (activeClassNames.length > 0) {
                        activeClassNames.forEach((className) => {
                            if (productItem.classList.contains(className)) {
                                hasClass = true;
                            }
                        });

                        if (hasClass) {
                            $(productItem).fadeIn();
                        } else {
                            $(productItem).fadeOut();
                        }
                    } else {
                        $(productItem).fadeIn();
                    }
                });
            })
        })

        const activeItems = document.querySelectorAll('.widget .list ul li ul li a.active');

        let activeClassNames = [];
        activeItems.forEach((activeItem) => {
            const url = new URL(activeItem.href);
            const pathParts = url.pathname.split('/');
            const className = pathParts[pathParts.length - 1];
            activeClassNames.push(className);
        });

        const productItems = document.querySelectorAll('.product-item-wrapper');

        productItems.forEach((productItem) => {
            let hasClass = false;

            if (activeClassNames.length > 0) {
                activeClassNames.forEach((className) => {
                    if (productItem.classList.contains(className)) {
                        hasClass = true;
                    }
                });

                if (hasClass) {
                    $(productItem).fadeIn();
                } else {
                    $(productItem).fadeOut();
                }
            } else {
                $(productItem).fadeIn();
            }
        });

        document.querySelectorAll('.reference-item .swiper').forEach(function (item) {
            new Swiper(item, {
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            })
        })
    }

    let global = () => {
        $('header').hover(function () {
            $(this).addClass('fixed')
        }, function () {
            $(this).removeClass('fixed')
        });
        //
        // $(window).on('scroll', function () {
        //     if ($(window).scrollTop() > 170) {
        //         $('header').addClass('scroll-fixed')
        //     } else {
        //         $('header').removeClass('scroll-fixed')
        //     }
        //
        // })

        $(window).scroll(function () {
            let header = $('header');

            if ($(window).scrollTop() >= 160) {
                header.addClass('scroll-fixed');

                if (header.hasClass('header-type-2')) {
                    $('body').css('padding-top', "92px");
                    setTimeout(function () {
                        header.find('.main-header').css({
                            'transition': 'transform 0.3s ease-in-out',
                            'transform': 'translateY(0)'
                        })
                    }, 300)
                }
            } else {
                header.removeClass('scroll-fixed');

                if (header.hasClass('header-type-2')) {
                    $('body').css('padding-top', 0);
                    header.find('.main-header').css({
                        'transition': '',
                        'transform': ''
                    })
                }
            }
        });

        document.querySelectorAll('.has-sub').forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                    item.querySelector('use').setAttribute('xlink:href', '/assets/img/icons.svg#plus');
                    $(item.parentElement.querySelector('.sub-categories')).slideUp();
                } else {
                    // document.querySelectorAll('.has-sub').forEach(function (item) {
                    //     item.classList.remove('active');
                    //     item.querySelector('use').setAttribute('xlink:href', '/assets/img/icons.svg#plus');
                    //     $(item.parentElement.querySelector('.sub-categories')).slideUp();
                    // });
                    item.classList.add('active');
                    item.querySelector('use').setAttribute('xlink:href', '/assets/img/icons.svg#minus');
                    $(item.parentElement.querySelector('.sub-categories')).slideDown();
                }
            });
        })

        $('.search-toggle').click(function () {
            setTimeout(function () {
                $('#searchInput').focus();
            }, 500);
            $('.search-area').slideToggle();
            $('.search-toggle .icon use').attr('xlink:href', function (index, attr) {
                return attr === '/assets/img/icons.svg#search' ? '/assets/img/icons.svg#times' : '/assets/img/icons.svg#search';
            })
        });

        $(document).click(function (event) {
            if (!$(event.target).closest('.search-box').length && !$(event.target).closest('.search-toggle').length) {
                if ($('.search-area').is(':visible')) {
                    $('.search-area').slideUp();
                    $('.search-toggle .icon use').attr('xlink:href', '/assets/img/icons.svg#search');
                }
            }
        });

        $('.close-sidebar, .widget-backdrop').click(function () {
            $('.mobile-menu-btn').trigger('click');
        });

        $('.mobile-menu-btn').on('click', function () {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
                $(this).find('svg').html('<use xlink:href="/assets/img/icons.svg#times"></use>')
                $(this).parents('aside').addClass('sidebar-active');
            } else {
                $(this).removeClass('active');
                $(this).find('svg').html('<use xlink:href="/assets/img/icons.svg#bars-light"></use>')
                $(this).parents('aside').removeClass('sidebar-active');
            }
        });

        let filterWrapper = $('.documents .filter');

        if (filterWrapper.length > 0) {
            let filterItems = filterWrapper.find('.form-check-input');
            let filesWrapper = $('.documents .files');
            let files = filesWrapper.find('.file-wrapper');
            let selectedValues = [];

            filterItems.each(function (index, item) {
                $(item).on('change', function () {
                    let selectedItems = filterItems.filter(':checked');
                    // if #all element is checked and there is another element checked, uncheck #all
                    if (selectedItems.length > 1 && $(this).attr('id') !== 'all') {
                        filterWrapper.find('#all').prop('checked', false).removeAttr('checked');
                    }

                    selectedValues = selectedItems.filter(function () {
                        return $(this).attr('id') !== 'all';
                    }).map(function () {
                        return $(this).val();
                    }).get();

                    // if #all element is checked, uncheck all other elements
                    if ($(this).attr('id') === 'all' && $(this).is(':checked')) {
                        filterWrapper.find('#all').prop('checked', true);
                        filterItems.not(this).prop('checked', false);
                        selectedValues = [];
                    }

                    files.each(function () {
                        let fileItem = $(this);
                        let fileClass = fileItem.data('type'); // Öğenin sınıfını al
                        if (selectedValues.length === 0) {
                            filterWrapper.find('#all').prop('checked', true);
                            fileItem.show();
                            console.log(selectedValues)
                            console.log(selectedValues.includes(fileClass))
                        } else if (selectedValues.includes(fileClass)) {
                            fileItem.show();
                        } else {
                            fileItem.hide();
                        }
                    });
                });
            });
        }

    }

    var mobilMenu = function () {
        if ($('header .mobile').length) {
            $('header .mobile').initMM({
                enable_breakpoint: true,
                mobile_button: true,
                breakpoint: 1200,
            });
        }

        $('.custom-panel-menu li a[role="button"]').click(function (e) {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
                $(this).parent().find('ul').first().slideDown();
                if ($(this).data('sub'))
                    $(this).find('svg use').attr('xlink:href', '/assets/img/icons.svg#minus')
            } else {
                $(this).removeClass('active');
                if ($(this).data('sub'))
                    $(this).find('svg use').attr('xlink:href', '/assets/img/icons.svg#plus')
                $(this).parent().find('ul').first().slideUp();
            }
        })

        if (window.innerWidth <= 440) {
            $('.footer-item .title').click(function (e) {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).find('svg use').attr('xlink:href', '/assets/img/icons.svg#minus')
                    $(this).parent().find('ul').first().slideDown();
                } else {
                    $(this).removeClass('active');
                    $(this).find('svg use').attr('xlink:href', '/assets/img/icons.svg#plus')
                    $(this).parent().find('ul').first().slideUp();
                }
            })
        }
    }


    return {
        init: function () {
            Fancybox.bind("[data-fancybox]", {});

            document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (item) {
                new Tooltip(item)
            })

            swiperUse();
            home();
            pages();
            global();
            mobilMenu();
            // intTelInput();
        },
    };
}();

// On document ready
jQuery(document).ready(function () {
    App.init();
});

